<template>
    <div>
        <div class="container w-full md:max-w-5xl mx-auto">
            <div class="font-sans">

                <h1 class="font-bold font-sans break-normal text-gray-900 pt-6 pb-2 text-3xl md:text-4xl">
                    Privacy Policy and Consent to Data Processing
                </h1>
            </div>
            <h2 class="font-bold font-sans break-normal text-gray-900 pb-2">
                Data recording in this website
            </h2>
            <p>
                Who is the responsible party for the recording of data on this website (i.e., the “controller”)?
            </p>
            <p class="py-3">
                The data on this website is processed by the operator of the website, whose contact information is
                available under section “Information about the responsible party (referred to as the “controller” in the
                GDPR)” in this Privacy Policy.
            </p>
            <h2 class="font-bold font-sans break-normal text-gray-900 pb-2">
                How do we record your data?
            </h2>
            <p>
                We collect your data as a result of your sharing of your data with us. This may, for instance be
                information you enter into our submit news form.
            </p>
            <p class="py-3">
                There is no information that is recorded automatically when you access this website.
            </p>

            <h2 class="font-bold font-sans break-normal text-gray-900 py-2">
                What are the purposes we use your data for?
            </h2>
            <p>
                The information we collect is to demostrate the creation of news article in this website.
            </p>

            <h2 class="font-bold font-sans break-normal text-gray-900 py-2">
                Data protection
            </h2>
            <p>
                The operators of this website and its pages take the protection of your personal data very seriously.
                Hence, we handle your personal data as confidential information and in compliance with the statutory
                data protection regulations and this Data Protection Declaration.
            </p>
            <h2 class="font-bold font-sans break-normal text-gray-900 py-2">
                SSL and/or TLS encryption
            </h2>
            <p>
                For security reasons and to protect the transmission of confidential content, such as purchase orders or
                inquiries you submit to us as the website operator, this website uses either an SSL or a TLS encryption
                program. You can recognize an encrypted connection by checking whether the address line of the browser
                switches from “http://” to “https://” and also by the appearance of the lock icon in the browser line.
            </p>
            <p class="py-2">
                If the SSL or TLS encryption is activated, data you transmit to us cannot be read by third parties.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GDPR',
}
</script>